<div
  class="confirmation-modal"
  (keydown)="onKeydown($event)"
  aria-labelledby="modal-title"
  [attr.aria-describedby]="description ? 'modal-description' : null"
>
  <mat-dialog-content class="modal-content">
    <h2
      id="modal-title"
      class="modal-title"
      [class.modal-title-primary]="titleColor === 'primary'"
      [class.modal-title-gray]="titleColor === 'gray'"
    >
      {{ title }}
    </h2>
    @if (description) {
      <p id="modal-description" class="modal-description">
        {{ description }}
      </p>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="modal-actions" align="end">
    <button
      mat-button
      (click)="onConfirm()"
      type="button"
      class="confirm-button modal-button"
      [class.confirm-button-primary]="confirmButtonColor === 'primary'"
      [class.confirm-button-warn]="confirmButtonColor === 'warn'"
      [class.confirm-button-success]="confirmButtonColor === 'success'"
    >
      {{ confirmText }}
    </button>
    <button
      mat-button
      (click)="onCancel()"
      type="button"
      class="cancel-button modal-button"
      cdkFocusInitial
    >
      {{ cancelText }}
    </button>
  </mat-dialog-actions>
</div>
